import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import useMediaQuery from "../../app/common/hooks/useMediaQuery";
import { useNavigate, useParams } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import { ReactComponent as LogoSvg } from "../../assets/altlogo.svg";
import { ReactComponent as Logo2Svg } from "../../assets/altlogo2.svg";
import { ReactComponent as AltBankLogoSvg } from "../../assets/altbanklogo.svg";
import { ReactComponent as EnigmaSvg } from "../../assets/enigma.svg";
import { ReactComponent as UserSvg } from "../../assets/user.svg";
import { ReactComponent as DownIconSvg } from "../../assets/downicon.svg";
import { ReactComponent as ScrollArrowSvg } from "../../assets/scrollarrow.svg";
import { ReactComponent as CBNLogoSvg } from "../../assets/CBNLOGO.svg";
import { ReactComponent as TABLogoSvg } from "../../assets/TABLOGO.svg";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react-lite";
import Loading from "../../app/layout/Loading";
import StarRatings from "react-star-ratings";
import agent from "../../app/api/agent";

const IndexVendorPage = () => {
  const [checked, setChecked] = useState(false);
  const params = useParams();
  const storeSlug = params.id!;
  const matches = useMediaQuery("(min-width: 800px)");
  const navigate = useNavigate();
  const { commonStore, userStore } = useStore();
  const {
    GetItem,
    loadingInitial,
    fetchVendorStore,
    currentStore,
    currentStoreProductList,
  } = commonStore;
  const token: string | null = GetItem("jwt");
  const { logout } = userStore;
  const loggedInUser = () => {
    try {
      const data = window.localStorage.getItem("user");
      return agent.decryptResponse(data);
    } catch {
      return null;
    }
  };
  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const scrollDown = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  const faq = process.env.REACT_APP_FAQ_URL;
  const returnPolicy = process.env.REACT_APP_RETURN_POLICY;
  const privacyPolicy = process.env.REACT_APP_PRIVACY_POLICY;
  const termsAndConditions = process.env.REACT_APP_T_AND_C;
  const paymentOptions = process.env.REACT_APP_PAYMENT_OPTIONS;
  const deliveryInformation = process.env.REACT_APP_DELIVERY_INFORMATION;
  const powerOptions = process.env.REACT_APP_POWER_OPTIONS;
  const aboutUs = process.env.REACT_APP_ABOUT;

  const count = useRef(0);
  const [currentFilter, setCurrentFilter] = useState({ value: "", code: 0 });
  const productList = currentStoreProductList.slice().sort(function (x, y) {
    if (currentFilter.value === "Price - Low to High") {
      let b = y.productCurrentPrice,
        a = x.productCurrentPrice;
      return a - b;
    } else if (currentFilter.value === "Price - High to Low") {
      let b = x.productCurrentPrice,
        a = y.productCurrentPrice;
      return a - b;
    } else if (currentFilter.value === "Product Ratings") {
      let b = y.rating,
        a = x.rating;
      return b - a;
    } else {
      let b = new Date(x.createdAt).getTime(),
        a = new Date(y.createdAt).getTime();
      return b - a;
    }
  });

  const isHttpUrl = (value: string) => /^https?:\/\//i.test(value);
const isDataUrl = (value: string) => /^data:/i.test(value);


const detectImageMime = (base64: string): string => {
  const sig = base64.slice(0, 24);
  if (sig.startsWith("iVBORw0KGgo")) return "image/png";
  if (sig.startsWith("/9j/")) return "image/jpeg";
  if (sig.startsWith("R0lGOD")) return "image/gif";
  if (sig.startsWith("UklGR")) return "image/webp";
  // Reasonable default for product photos when the signature is unrecognized
  return "image/png";
};

const resolveImageSrc = (value?: string | null): string | undefined => {
  if (!value || value === null) return undefined;

  // Already a normal URL or a properly formed data URI — use as-is
  if (isHttpUrl(value) || isDataUrl(value)) return value;

  // Otherwise treat it as raw base64 and build the data URI ourselves
  const cleaned = value.replace(/\s/g, "");
  const mime = detectImageMime(cleaned);
  return `data:${mime};base64,${cleaned}`;
};

const PLACEHOLDER_IMAGE_SRC =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
      <rect width="200" height="200" fill="#F0F0F0"/>
      <g fill="none" stroke="#BDBDBD" stroke-width="4">
        <rect x="30" y="40" width="140" height="120" rx="6"/>
        <circle cx="70" cy="80" r="12"/>
        <path d="M30 140 L80 100 L110 125 L140 95 L170 140" />
      </g>
      <text x="100" y="180" font-family="Arial, sans-serif" font-size="12" fill="#9E9E9E" text-anchor="middle">
        No Image
      </text>
    </svg>
  `);

  useEffect(() => {
    if (loadingInitial !== "loading" && count.current === 0) {
      count.current = count.current + 1;
      fetchVendorStore(storeSlug);
      // console.log("currentStoreProductList", currentStore);
    } else {
      // navigate("/vendors");
    }
  }, []);
  return (
    <>
      {loadingInitial === "loading" && <Loading />}
      <div className={styles.origin}>
        <div className={styles.mainWrapper}>
          <div className={styles.page}>
            <div className={styles.navWrapper}>
              <div className={styles.nav}>
                <div
                  className={`${styles.navcheck} ${checked && styles.checked}`}
                />
                <div className={styles.navheader}>
                  <div className={styles.navtitle}>
                    <LogoSvg onClick={() => navigate("/")} />
                  </div>
                </div>
                <div
                  className={styles.navbtn}
                  onClick={() => setChecked(!checked)}
                >
                  <label htmlFor="navcheck">
                    <span></span>
                    <span></span>
                    <span></span>
                  </label>
                </div>

                <div className={styles.navlinks}>
                  <span>
                    {" "}
                    <div className={styles.flexCenter}>
                      <EnigmaSvg />
                      <span>Help</span>
                      <Popup
                        trigger={<DownIconSvg style={{ cursor: "pointer" }} />}
                        content={
                          <div className={styles.menu}>
                            <div
                              onClick={() => window.open(faq, "_blank")}
                              style={{ cursor: "pointer" }}
                            >
                              FAQs
                            </div>
                            <hr />
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => scrollDown()}
                            >
                              Contact Us
                            </div>
                            <hr />
                            {returnPolicy && (
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  window.open(returnPolicy, "_blank")
                                }
                              >
                                Return Policy
                              </div>
                            )}
                          </div>
                        }
                        on="click"
                        position="bottom center"
                      />
                    </div>
                  </span>
                  <span>
                    {" "}
                    <div className={styles.flexCenter}>
                      <UserSvg />
                      <span
                        style={{
                          cursor: !token || token === null ? "pointer" : "",
                        }}
                        onClick={() =>
                          (!token || token === null) && navigate("/login")
                        }
                      >
                        {loggedInUser() ? "Account" : "Sign in"}
                      </span>
                      {token && matches && (
                        <Popup
                          trigger={
                            loggedInUser() && (
                              <DownIconSvg style={{ cursor: "pointer" }} />
                            )
                          }
                          header={`${
                            loggedInUser() && loggedInUser()!.firstName
                          } ${
                            loggedInUser() && loggedInUser().lastName !== null
                              ? loggedInUser().lastName
                              : ""
                          }`}
                          content={
                            <div className={styles.menu}>
                              <hr />
                              <div
                                onClick={() => navigate("/vendor/dashboard")}
                                style={{ cursor: "pointer" }}
                              >
                                Dashboard
                              </div>
                              <hr />
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() => logout()}
                              >
                                Log Out
                              </div>
                            </div>
                          }
                          on="click"
                          position="bottom center"
                        />
                      )}
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.currentStoreBannerWrapper}>
              <img
                src={resolveImageSrc(currentStore?.headerImageUrl) || PLACEHOLDER_IMAGE_SRC}
                alt="store header pic"
                className={styles.currentStoreBanner}
                onError={(e) => (e.currentTarget.src = PLACEHOLDER_IMAGE_SRC)}
              />
              <div className={styles.logoandname}>
                <div className={styles.logocontainer}>
                  <img
                    src={resolveImageSrc(currentStore?.storeLogoUrl) || PLACEHOLDER_IMAGE_SRC}
                    alt="store logo pic"
                    className={styles.currentStoreLogo}
                    onError={(e) => (e.currentTarget.src = PLACEHOLDER_IMAGE_SRC)}
                  />
                </div>
                <p>{currentStore && currentStore.storeName}</p>
              </div>
            </div>
            <div className={styles.currentStore}>
              {productList && productList.length > 2 && (
                <div className={styles.filter}>
                  <div className={styles.sortby}>Sort by</div>
                  <div
                    className={styles.filteroption}
                    onClick={() =>
                      setCurrentFilter({
                        value: "Price - Low to High",
                        code: 1,
                      })
                    }
                  >
                    Price - Low to High
                  </div>
                  <div
                    className={styles.filteroption}
                    onClick={() =>
                      setCurrentFilter({
                        value: "Price - High to Low",
                        code: 2,
                      })
                    }
                  >
                    Price - High to Low
                  </div>
                  <div
                    className={styles.filteroption}
                    onClick={() =>
                      setCurrentFilter({ value: "Product Ratings", code: 3 })
                    }
                  >
                    Product Ratings
                  </div>
                  <div
                    className={styles.filteroption}
                    onClick={() =>
                      setCurrentFilter({ value: "Latest Arrivals", code: 4 })
                    }
                  >
                    Latest Arrivals
                  </div>
                </div>
              )}
              <div className={styles.productList}>
                {productList &&
                  productList.map((product, index) => {
                    return (
                      <div className={styles.product} key={index}>
                        <div className={styles.payment}>
                          ₦{product.monthlyFinancing}/ <span>Month</span>
                        </div>
                        <div className={styles.productimage}>
                          <img
                            src={resolveImageSrc(product.productPrimaryImageUrl) || PLACEHOLDER_IMAGE_SRC}
                            alt="product pic"
                            onError={(e) => (e.currentTarget.src = PLACEHOLDER_IMAGE_SRC)}
                          />
                        </div>
                        <div className={styles.productName}>
                          {product.productName}
                        </div>
                        <div className={styles.price}>
                          ₦ {product.productCurrentPrice}
                        </div>
                        <div className={styles.ratings}>
                          {/* <FiveStarsSvg /> */}
                          <StarRatings
                            rating={product.rating}
                            starRatedColor="#F2C94C"
                            starDimension="10px"
                            starSpacing="2px"
                            // changeRating={this.changeRating}
                            numberOfStars={5}
                            name="rating"
                          />
                        </div>
                        <div className={styles.soldby}>
                          Sold by{" "}
                          <span>{currentStore && currentStore.storeName}</span>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          <div className={styles.footer}>
            <div className={styles.content}>
              <Logo2Svg />
              <div className={styles.footerlinks}>
                <div onClick={() => window.open(aboutUs, "_blank")}>
                  About Us
                </div>
                <div onClick={() => window.open(termsAndConditions, "_blank")}>
                  Terms & Conditions
                </div>
                <div onClick={() => navigate("/login")}>My Account</div>
              </div>
              <div className={styles.footerlinks}>
                <div onClick={() => window.open(deliveryInformation, "_blank")}>
                  Delivery Information
                </div>
                <div onClick={() => window.open(paymentOptions, "_blank")}>
                  Payment Options
                </div>
                <div onClick={() => window.open(powerOptions, "_blank")}>
                  Power As A Service
                </div>
              </div>
              <div className={styles.footerlinks}>
                <div onClick={() => window.open(privacyPolicy, "_blank")}>
                  Privacy Policy
                </div>
                <div
                  onClick={() => window.open(faq, "_blank")}
                  className={styles.sterlink}
                >
                  FAQ
                </div>
                <div onClick={() => window.open(returnPolicy, "_blank")}>
                  Return Policy
                </div>
              </div>
              <div className={styles.footerlinks}>
                <h5>02017000555</h5>
                <div
                  className={styles.emaillink}
                  onClick={() =>
                    window.open("mailto:service@altpower.ng", "_blank")
                  }
                >
                  service@altpower.ng
                </div>
                {/* <div className={styles.altbanklogo}>
                  <AltBankLogoSvg />
                </div> */}
              </div>
            </div>
            <div className={styles.scrollup} onClick={() => scrollUp()}>
              <div className={styles.arrowdown}>
                {" "}
                <ScrollArrowSvg />
              </div>
            </div>
            <div className={styles.copyright}>
              <span>
                Licensed by Cental Bank Of Nigeria <CBNLogoSvg />
              </span>
              <span>|</span>
              <span>Powered by</span>
              <span>
                <TABLogoSvg />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(IndexVendorPage);
